import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

import { vendorQueryKeys } from './useGetVendorsByIds';

export interface VendorParent {
  id_salesforce_external: string;
  parent_id?: string | null;
  parent_name?: string | null;
  vendor_name?: string | null;
}

interface VendorParentsResponse {
  status: number;
  result: Array<VendorParent>;
}

export function useGetVendorParent(vendorId?: string) {
  return useQuery<VendorParent | undefined>({
    queryKey: vendorQueryKeys.parent(vendorId ?? ''),
    queryFn: async () => {
      if (!vendorId) {
        throw new Error('vendorId is required');
      }

      const response: VendorParentsResponse = await VendorsService.getVendorParents([vendorId]);
      return response.result.find((vendorParent) => vendorParent.id_salesforce_external === vendorId);
    },
    enabled: !!vendorId,
  });
}
